import React from 'react';

/**
 * GapGo branding + RedSpeed attribution.
 *
 * Two variants because the two screens that use it now have opposite backgrounds:
 * GuestMenu is dark (the guest's phone) and KitchenPanel is light (a wall-mounted
 * tablet in a bright room — see pages/kitchenPanelCss.js). The dark bar rendered as
 * a black slab across the bottom of the white kitchen screen.
 *
 * `dark` stays the default so the guest flow is untouched.
 */
export default function RestaurantFooter({ variant = 'dark' }) {
  const light = variant === 'light';

  return (
    <div
      style={{
        background: light ? '#FFFFFF' : '#080808',
        borderTop: `1px solid ${light ? '#E4E7EC' : '#333'}`,
        padding: '24px 20px',
        textAlign: 'center',
        marginTop: 'auto',
      }}
    >
      <div style={{ fontSize: '16px', fontWeight: 600, color: light ? '#12141A' : '#fff', marginBottom: '4px' }}>
        GapGo 2026
      </div>
      <div style={{ fontSize: '12px', color: light ? '#858B99' : '#888' }}>
        Powered by Redspeed Technologies
      </div>
    </div>
  );
}
